import { render, staticRenderFns } from "./NewTaxesAnnouncement.vue?vue&type=template&id=9dd0c884&scoped=true"
import script from "./NewTaxesAnnouncement.vue?vue&type=script&lang=js"
export * from "./NewTaxesAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./NewTaxesAnnouncement.vue?vue&type=style&index=0&id=9dd0c884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd0c884",
  null
  
)

export default component.exports